import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import TimeframeButtons from './TimeframeButtons';

export const ChartContainer = styled.div`
  width: 100%;

  a {
    display: flex;
    height: 100%;
  }
`;

export const EmptyStateWrapper = styled.div`
  background: ${color.light};
  border: none;
  padding: 20px;

  > .no-data {
    padding: 20px 0;
    text-align: center;

    > .text-empty-state {
      color: ${color.highgray};
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      margin-top: 18px;
    }
  }

  @media ${device.tablet} {
    padding: 30px 40px;
  }
`;

export const ChartWrapper = styled.div`
  background: ${color.light};
  border: none;
  padding: 20px;

  @media ${device.tablet} {
    border-top: none;
    padding-top: 8px;
  }
`;

export const CustomIconmoon = styled(Iconmoon)`
  line-height: 1;
  font-size: 14px;

  &.icon-symbol_up:before {
    content: '\\25B2';
    display: inline-block;
    font-size: 13px;
    padding-bottom: 4px;
    padding-left: 5px;
  }
  &.icon-symbol_down:before {
    content: '\\25BC';
    display: inline-block;
    font-size: 12px;
    padding-bottom: 4px;
    padding-left: 5px;
  }
`;

export const ResponsiveText = styled(Text)`
  font-size: 14px;
  letter-spacing: -0.25px;

  @media ${device.tablet} {
    font-size: 16px;
  }
`;

export const CurrentPriceText = styled(Text)`
  font-size: 14px;
  padding-right: 0;
  letter-spacing: -0.25px;

  @media ${device.tablet} {
    font-size: 16px;
    padding-right: 5px;
  }
`;

export const TimeText = styled(Text)`
  display: none;

  @media ${device.tablet} {
    display: block;
  }
`;

export const TimeframeButtonsMobile = styled(TimeframeButtons)`
  display: block;
  padding-left: 30px;
  text-align: end;

  @media ${device.tablet} {
    display: none;
  }

  .text {
    font-size: 12px;
    width: 29px;
  }
`;

export const TimeframeButtonsDesktop = styled(TimeframeButtons)`
  display: none;

  @media ${device.tablet} {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }

  .text {
    font-size: 13px;
    width: 30px;
  }

  .ant-radio-button-wrapper {
    border-right: none;

    &:last-child {
      border-right: 1px solid ${color.gainsboro};
    }
  }
`;

export const ExpandButtonToggleWrapper = styled.div`
  display: none;

  @media ${device.tablet} {
    display: block;
  }
`;

export const MainChartWrapper = styled.div`
  margin-top: 20px;
  padding-top: 8px;

  @media ${device.tablet} {
    margin-top: 0px;
  }
`;

export const MainChartContent = styled.div`
  min-height: 300px;
`;

export const ChartSectionItem = styled.div`
  display: none;

  @media ${device.tablet} {
    display: block;
    margin-left: 25px;
  }
`;

export const NotHoverIcon = styled(Iconmoon)`
  display: inline;

  :hover {
    color: inherit;
  }
`;
